var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { COMPONENT_STRINGS } from "../../constants";
// Fonte única: as opções de categoria dos formulários de denúncia. Os forms
// anônimo e identificado têm listas distintas, então unimos as duas para cobrir
// qualquer valor já gravado. Mapeia o slug (value) -> label legível.
var CATEGORY_OPTIONS = __spreadArray(__spreadArray([], COMPONENT_STRINGS.ANONYMOUS_COMPLAINT_FORM.FIELDS.IRREGULARITY_TYPE
    .OPTIONS, true), COMPONENT_STRINGS.IDENTIFIED_COMPLAINT_FORM.FIELDS.IRREGULARITY_TYPE
    .OPTIONS, true);
var CATEGORY_LABELS = CATEGORY_OPTIONS.reduce(function (acc, _a) {
    var value = _a.value, label = _a.label;
    acc[value] = label;
    return acc;
}, {});
/**
 * Converte o slug de categoria (ex.: "preco_abusivo") na label legível
 * (ex.: "Preço abusivo"). Para valores desconhecidos, formata o slug trocando
 * "_" por espaço e capitalizando, em vez de exibir o ID cru.
 */
export function categoryLabel(value) {
    if (!value)
        return "—";
    if (CATEGORY_LABELS[value])
        return CATEGORY_LABELS[value];
    return value.replace(/_/g, " ").replace(/\b\w/g, function (c) { return c.toUpperCase(); });
}
